import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';
import type { SearchSettingsConfig } from '@uncinc/react-searchkit/types';

import { requestOptions, sorting } from './config';
import { facetAttributes, resultAttributes } from '../SearchTopical/config';
import topicalRouting from '../SearchTopical/routing';

import {
  APP_OPTIONS,
  SEARCHKIT_HITS_PER_PAGE_TOPICAL,
  SEARCHKIT_HOST_URL,
} from '../../config/constants';

// Subcomponents.
import AdvancedFacets from '../SearchTopical/AdvancedFacets';
import Facets from '../SearchTopical/Facets';
import ResultsArticles from '../SearchTopical/Results/Articles';

import '../SearchTopical/style.scss';

interface SearchTopicalArticlesSubComponents {
  AdvancedFacets: typeof AdvancedFacets;
  Facets: typeof Facets;
  ResultsArticles: typeof ResultsArticles;
}

export interface SearchTopicalArticlesProps extends Omit<SearchkitWrapperProps, 'connection' | 'searchSettings' | 'indexName'> {
  searchSettings?: Partial<SearchSettingsConfig>;
}

const SearchTopicalArticles: React.FC<SearchTopicalArticlesProps>
& SearchTopicalArticlesSubComponents = (props) => {
  const {
    className,
    children,
  } = props;

  const classNames = c('SearchTopical', className);

  return (
    <SearchkitWrapper
      className={classNames}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      routing={topicalRouting}
      indexName={APP_OPTIONS.parameters.searchkitIndexTopical}
      hitsPerPage={SEARCHKIT_HITS_PER_PAGE_TOPICAL}
      searchSettings={{
        search_attributes: [],
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
        sorting,
      }}
      requestOptions={requestOptions}
    >
      { children }
    </SearchkitWrapper>
  );
};

SearchTopicalArticles.AdvancedFacets = AdvancedFacets;
SearchTopicalArticles.Facets = Facets;
SearchTopicalArticles.ResultsArticles = ResultsArticles;

export default SearchTopicalArticles;
